<template>
  <InfoCard :title="t('Редакция СМИ', options)">
    <ul
      class="document-list text-body-2 ma-0 pa-0"
      data-qa="document_media_list"
    >
      <li
        class="document-list__item mb-3"
        data-qa="document_media_item"
      >
        {{ t('Сайт', options) }}
        <a
          href="/"
          class="link-decoration-underline primary--text"
          data-qa="document_media_site_link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ siteDomain }}
        </a>
        {{ t('зарегистрирован Федеральной службой по надзору в сфере связи,', options) }}
        {{ t('информационных технологий и массовых коммуникаций (Роскомнадзор).', options) }}
      </li>
      <li
        class="document-list__item mb-3"
        data-qa="document_media_item"
      >
        {{ t('Свидетельство', options) }}
        <CorePRG
          url="https://rkn.gov.ru/activity/mass-media/for-founders/media/?id=446956"
          :button-attrs="{
            class: 'link-decoration-underline primary--text pa-0',
            'data-qa': 'document_media_certificate_link',
          }"
        >
          {{ t('ЭЛ № ФС 77 - 89293 от 01.04.2025 г.', options) }}
        </CorePRG>
      </li>
      <li
        class="document-list__item mb-3"
        data-qa="document_media_item"
      >
        {{ t('Учредитель СМИ (издатель) ООО «МЕДРОКЕТ»', options) }}
      </li>
      <li
        class="document-list__item mb-3"
        data-qa="document_media_item"
      >
        {{ t('Главный редактор - Федосов Сергей Ростиславович', options) }}
      </li>
      <li
        class="document-list__item mb-3"
        data-qa="document_media_item"
      >
        {{ t('Адрес редакции (издателя):', options) }}
        {{ editorialAddress }}
      </li>
      <li
        class="document-list__item mb-3"
        data-qa="document_media_item"
      >
        {{ t('Телефон:', options) }}
        <a
          href="tel:+74953749356"
          class="link-decoration-underline primary--text"
          data-qa="document_media_phone_link"
        >
          8 (495) 374-93-56
        </a>
      </li>
      <li
        class="document-list__item mb-3"
        data-qa="document_media_item"
      >
        {{ t('Email:', options) }}
        <a
          href="mailto:help@medrocket.ru"
          class="link-decoration-underline primary--text"
          data-qa="document_media_email_link"
          target="_blank"
          rel="noopener noreferrer"
        >
          help@medrocket.ru
        </a>
      </li>
    </ul>
  </InfoCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import I18NextVue from 'i18next'
import InfoCard from 'src/components/pages/info/about-us/index/components/MainContent/components/InfoCard.vue'
import CorePRG from 'src/core/CorePRG/CorePRG.vue'
import formatCompanyAddress from 'src/components/pages/info/document/index/_functions/format-company-address'
import type { CompanyPhysicalAddress } from 'src/components/pages/info/document/index/types'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  siteDomain: string
  physicalAddress?: CompanyPhysicalAddress
}>()

const editorialAddress = computed(() => (
  formatCompanyAddress(props.physicalAddress, 'legal')
))
</script>

<style scoped lang="scss">
.document-list {
  list-style: none;

  &__item:last-child {
    margin-bottom: 0 !important;
  }
}
</style>
